import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AvatarPhotoComponent } from './components/avatar-photo/avatar-photo.component';
import { DocumentCardComponent } from './components/document-card/document-card.component';
import { ElementListComponent } from './components/element-list/element-list.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalComponent } from './components/modal/modal.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NoticeConfidentialityComponent } from './components/notice-confidentiality/notice-confidentiality.component';
import { NotificationComponent } from './components/notification/notification.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchInputDropdownComponent } from './components/search-input-dropdown/search-input-dropdown.component';
import { SearchInputSelectComponent } from './components/search-input-select/search-input-select.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarMenuItemComponent } from './components/sidebar-menu-item/sidebar-menu-item.component';
import { TitleComponent } from './components/title/title.component';
import { ViewerComponent } from './components/viewer/viewer.component';

@NgModule({
  declarations: [
    AvatarPhotoComponent,
    DocumentCardComponent,
    ElementListComponent,
    LoaderComponent,
    ModalComponent,
    NavbarComponent,
    NoticeConfidentialityComponent,
    NotificationComponent,
    SearchInputComponent,
    SearchInputDropdownComponent,
    SearchInputSelectComponent,
    SettingsComponent,
    SidebarComponent,
    SidebarMenuItemComponent,
    TitleComponent,
    ForbiddenComponent,
    ViewerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    DocumentCardComponent,
    ElementListComponent,
    LoaderComponent,
    ModalComponent,
    NavbarComponent,
    NoticeConfidentialityComponent,
    NotificationComponent,
    SearchInputComponent,
    SearchInputDropdownComponent,
    SearchInputSelectComponent,
    SettingsComponent,
    SidebarComponent,
    TitleComponent,
    ViewerComponent,
  ]
})
export class SharedModule { }
